import React from 'react'
import { Avatar } from './Avatar.jsx'

/** Body-only boxer silhouette (head is overlaid as an HTML <img> for reliable loading). */
function Body({ silhouette, glove, flip }) {
  return (
    <svg
      viewBox="0 0 132 172"
      className="absolute inset-0 w-full h-full"
      style={flip ? { transform: 'scaleX(-1)' } : undefined}
      aria-hidden="true"
    >
      <ellipse cx="63" cy="158" rx="48" ry="6" fill="#000" opacity="0.28" />
      <g stroke={silhouette} strokeLinecap="round" strokeLinejoin="round" fill="none">
        <g strokeWidth="18">
          <path d="M58 100 L44 126 L32 150" />
          <path d="M62 100 L80 124 L94 150" />
        </g>
        <path d="M60 100 L70 62" strokeWidth="28" />
        <g strokeWidth="13">
          <path d="M64 68 L50 60 L62 50" />
          <path d="M72 68 L86 62 L76 50" />
        </g>
      </g>
      <circle cx="62" cy="50" r="9.5" fill={glove} />
      <circle cx="76" cy="50" r="9.5" fill={glove} />
    </svg>
  )
}

/**
 * A friendly stylized boxer in a guard stance. The head is the player's profile
 * photo. Faces right by default; `flip` mirrors it toward the opponent.
 */
export function Duelist({
  src,
  name,
  seed,
  silhouette = '#dbeafe',
  glove = '#22d3ee',
  ring = '#22d3ee',
  height = 150,
  flip = false,
  className = '',
}) {
  const width = (height * 132) / 172
  const headSize = (width * 30) / 132
  const headLeft = flip ? width - (width * 85) / 132 : (width * 55) / 132
  const headTop = (height * 25) / 172

  return (
    <div
      className={`relative ${className}`}
      style={{ width, height }}
      role="img"
      aria-label={name || 'jugador'}
    >
      <Body silhouette={silhouette} glove={glove} flip={flip} />
      <div className="absolute" style={{ left: headLeft, top: headTop, width: headSize, height: headSize }}>
        <Avatar src={src} name={name} seed={seed} size={Math.round(headSize)} ring={ring} />
      </div>
    </div>
  )
}
